import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Publishment } from '../db/Publishment.js';

export const getPublishments = registerQuery({
  type: () => [Publishment],
  operationName: 'getPublishments',
  resolve: (entityIDs: string[]) => {
    return async (gqlFields: BaseQLSelectionSet<Publishment>) => {
      const collection = await getCollection<Publishment>(Publishment._class);
      const publishments = await collection.find<Publishment>({ entityID: { $in: entityIDs } }).toArray();
      return publishments;
    };
  },
  params: [{ name: 'entityIDs', type: () => [String] }],
});
